import ConfigStore from "./ConfigStore";

const configStore = new ConfigStore();

export default configStore;
export { Flags } from "./flags";
